module.exports = __webpack_public_path__ + "static/media/400152_02.d59f3c76.png";